/**
 * @generated SignedSource<<8cf710fbe95a16b7b8fcff02894df348>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tableBody_nativeIssueTable_project$data = {
  readonly key: string;
  readonly " $fragmentType": "tableBody_nativeIssueTable_project";
};
export type tableBody_nativeIssueTable_project$key = {
  readonly " $data"?: tableBody_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "tableBody_nativeIssueTable_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "cfc6b38de1e391ca690f6cbf9793a14f";

export default node;
